import react, { useEffect, useState } from "react";
import axios from "axios";
import MenuEmpresas from "./menuempresas";
import InformacionCuenta from "./informacion-cuenta";
import Box from "@mui/joy/Box";
import AspectRatio from "@mui/joy/AspectRatio";
import Typography from "@mui/joy/Typography";
import CircularProgress from "@mui/joy/CircularProgress";
import InformacionCuentaEmpresas from "./informacion-cuenta-empresas";

export default function RedireccionPerfil() {
  let [cuenta, setCuenta] = react.useState();

  useEffect(() => {
    async function getInfo() {
      try {
        let token = localStorage.getItem("token");
        let getInfoCuenta = await axios.get(
          `${process.env.REACT_APP_FRONTEND_URL}/api/escritorio/informacion-cuenta`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        console.log("gola");
        console.log(getInfoCuenta);
        setTimeout(() => {
          setCuenta(getInfoCuenta.data.tipo);
        }, 2000);
      } catch (err) {
        console.log("tenemos un error al obtener la información: " + err);
      }
    }
    getInfo();
  }, []);

  if (!cuenta) {
    return (
      <div>
        <MenuEmpresas />
        <Box
          sx={{
            display: "grid",
            width: "100vw",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
            }}
            className={"hola"}
          >
            <AspectRatio
              variant="plain"
              ratio="1"
              sx={{
                width: "50%",
                marginBottom: "2rem",
                borderRadius: "12px",
              }}
            >
              <img
                src={`${process.env.REACT_APP_FRONTEND_URL}/uploads/logo.svg`}
                alt="logo"
                style={{ objectFit: "contain" }}
              />
            </AspectRatio>
          </Box>
          <Typography level="body-xs">
            Cargando la información de tu cuenta
          </Typography>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: 5,
            }}
          >
            <CircularProgress color="success" variant="soft" />
          </Box>
        </Box>
      </div>
    );
  }

  if (cuenta === "guiaturistico") {
    return (
      <div>
        <InformacionCuenta />
      </div>
    );
  }
  if (cuenta === "empresa") {
    return (
      <div>
        <InformacionCuentaEmpresas />
      </div>
    );
  }
}
